export class CredentialsModel {
    constructor(public username?: string, public password?: string) { }
}



// WEBPACK FOOTER //
// ./src/app/views/user/models/credentials.model.ts